import CusSelectDialog from './CusSelectDialog.vue'
import SupermarketSelectDialog from './SupermarketSelectDialog.vue'
import SkuSelectDialog_s from '@/components/Dialog/SkuSelectDialog'

export const CusDialog = CusSelectDialog
export const SupermarketDialog = SupermarketSelectDialog

export const SkuSelectDialog = SkuSelectDialog_s